import { useSocrativeRouter } from '~teacher/context/RouterContext';

import { uniqueIdFactory } from '../../../../../api/quiz/getQuizzes/normalize/uniqueIds';

export function useParentId(quizFolderPath: string) {
  const router = useSocrativeRouter();
  const parentId = uniqueIdFactory['folder'].toEntityId(quizFolderPath);
  const setParentId = (newParentId: number) => {
    router.navigate(
      `quizzes/${
        newParentId != null
          ? uniqueIdFactory.folder.toUniqueId(newParentId)
          : ''
      }`,
      { trigger: true, replace: true }
    );
  };
  return { parentId, setParentId };
}
